import { render, staticRenderFns } from "./systemAttribute.vue?vue&type=template&id=b3a496a6&scoped=true&"
import script from "./systemAttribute.vue?vue&type=script&lang=js&"
export * from "./systemAttribute.vue?vue&type=script&lang=js&"
import style0 from "./systemAttribute.vue?vue&type=style&index=0&id=b3a496a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a496a6",
  null
  
)

export default component.exports